import React from "react";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

import { CloseDialogContext } from "../common/DialogComponent";
interface IProps {
    setConfirmCase: any;
    type: string;
}
const OpenCaseConfirmation = ({ setConfirmCase, type }: IProps) => {
    const { t: tLang } = useTranslation();
    const close: any = React.useContext(CloseDialogContext);
    const closeDialog = (confirmCase: boolean) => {
        setConfirmCase(confirmCase);
        close("open-case-confirmation");
    };
    return (
        <div>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="briefcase" />
                </div>
                {type === "resolveCase" ? (
                    <h3 className="content-sub-title">{tLang("alerts.cases.resolveCaseConfirmationPopup.title")}</h3>
                ) : (
                    <h3 className="content-sub-title">{tLang("alerts.alerts.openCaseConfirmation.title")}</h3>
                )}
            </div>
            <div className="dialog-body">
                {type === "resolveCase" ? (
                    <p>{tLang("alerts.cases.resolveCaseConfirmationPopup.message")}</p>
                ) : (
                    <p>{tLang("alerts.alerts.openCaseConfirmation.message")}</p>
                )}
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button onClick={() => closeDialog(false)} type="button" className="btn-default btn-link">
                            <span className="btn-text">
                                {type === "resolveCase"
                                    ? tLang("alerts.cases.resolveCaseConfirmationPopup.backToCaseLinkText")
                                    : tLang("alerts.alerts.openCaseConfirmation.backToAlert")}{" "}
                            </span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button onClick={() => closeDialog(true)} type="button" className="btn-default btn-primary">
                            <span className="btn-text">
                                {type === "resolveCase"
                                    ? tLang("alerts.cases.buttonText.resolveCase")
                                    : tLang("alerts.alerts.activeAlertPopup.buttonText.openacase")}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpenCaseConfirmation;
